import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface License {
    licenseKey: string | null,
    licenseData: string | null,
    stepIncrease: number,
    isClickable: boolean,
}

const initialState: License = {
    licenseKey: null,
    stepIncrease: 1,
    isClickable: false,
    licenseData: null
}

export const LicenseSlice = createSlice({
    name: "license",
    initialState,
    reducers: {
        setCurrentLicenseKey: (state, action: PayloadAction<string>) => {
            state.licenseKey = action.payload
        },
        setStepIncrease: (state, action: PayloadAction<number>) => {
            state.stepIncrease = action.payload
        },
        setLicenseData: (state, action: PayloadAction<string>) => {
            state.licenseData = action.payload
        },
        setClickable: (state, action: PayloadAction<boolean>) => {
            state.isClickable = action.payload
        }
    }
})

export default LicenseSlice.reducer
export const {setCurrentLicenseKey, setClickable, setLicenseData, setStepIncrease} = LicenseSlice.actions